import { userConstants, commonConstants, paymentConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { countryEffect } from '../_effects/countryEffect';
import { alertActions } from './alertActions';

export const countryAction = {
  getCountries,
  getRemitCountry,
  getRemitCurrency,
  clearCurrencyService,
};

function getCountries(countries) {
  return (dispatch) => {
    dispatch(request(countries));
    countryEffect.getCountries(countries).then(
      (countries) => {
        dispatch(success(countries));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(country) {
    return { type: commonConstants.COUNTRY_REQUEST, country };
  }
  function success(country) {
    return { type: commonConstants.COUNTRY_SUCCESS, country };
  }
  function failure(error) {
    return { type: commonConstants.COUNTRY_FAILURE, error };
  }
}

function getRemitCountry(remitCountry) {
  return (dispatch) => {
    dispatch(request(remitCountry));
    countryEffect.getRemitCountry(remitCountry).then(
      (remitCountry) => {
        dispatch(success(remitCountry));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(remitCountry) {
    return { type: paymentConstants.GET_REMIT_COUNTRY_REQUEST, remitCountry };
  }
  function success(remitCountry) {
    return { type: paymentConstants.GET_REMIT_COUNTRY_SUCCESS, remitCountry };
  }
  function failure(error) {
    return { type: paymentConstants.GET_REMIT_COUNTRY_FAILURE, error };
  }
}

function clearCurrencyService() {
  return (dispatch) => {
    dispatch(clearCurValues());
    dispatch(clearServValues());
    dispatch(clearServPValues());
    dispatch(clearAgentValues());
  };
}

function clearCurValues() {
  return { type: paymentConstants.CLEAR_BENEF_VALUES, payload: null };
}

function clearServValues() {
  return { type: commonConstants.CLEAR_SERVICES, payload: null };
}

function clearServPValues() {
  return { type: commonConstants.CLEAR_SERVICE_PROVIDER, payload: null };
}

function clearAgentValues() {
  return { type: commonConstants.CLEAR_AGENT, payload: null };
}

function getRemitCurrency(remitCurrency) {
  return (dispatch) => {
    dispatch(request(remitCurrency));
    countryEffect.getRemitCurrency(remitCurrency).then(
      (remitCurrency) => {
        dispatch(success(remitCurrency));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(remitCurrency) {
    return { type: paymentConstants.GET_REMIT_CURRENCY_REQUEST, remitCurrency };
  }
  function success(remitCurrency) {
    return { type: paymentConstants.GET_REMIT_CURRENCY_SUCCESS, remitCurrency };
  }
  function failure(error) {
    return { type: paymentConstants.GET_REMIT_CURRENCY_FAILURE, error };
  }
}
